import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initFrontendSentry } from "./observability/sentry";

// Initialize Sentry as early as possible — before any of our code
// that might throw runs. No-op when REACT_APP_SENTRY_DSN is empty
// (the v1 dev default), so this is safe to ship without a Sentry
// account configured.
initFrontendSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
